﻿export const tabswitcherFunctions = () => {
  const tabSwitchers = document.querySelectorAll(".snippet-tab-switcher");

  tabSwitchers.forEach((item) => {
    SetActiveDropDownHeaderMobile(item);
    TabSwitcherClickHandlers(item);
  });
};

export const SetActiveDropDownHeaderMobile = (item) => {
  const text = getActiveTabText(item);
  m_setActiveDropdownHeading(item, text);
};

export const TabSwitcherClickHandlers = (item) => {
  m_dropDownToggle(item);
  const buttons = item.querySelectorAll(".snippet-tab-switcher__button");
  buttons.forEach((button, idx) => {
    button.addEventListener("click", function () {
      removeActiveClassOnButtonClick(this);
      addActiveClassOnButtonClick(this);
      removeActiveClassOnSection(item);
      setActiveClassOnSection(item, idx);
      const text = getActiveTabText(item);
      m_setActiveDropdownHeading(item, text);
      changeHrefOnLinkClick(item, this);
      slideUpContainer(item);
    });
  });
};

const getActiveTabText = (item) => {
  let activeHeading = item.querySelector(
    ".snippet-tab-switcher__button--active"
  )?.textContent;

  if (!activeHeading) return;

  return activeHeading;
};

const m_setActiveDropdownHeading = (item, text) => {
  const dropDownHeader = item.querySelector(
    ".snippet-tab-switcher__active-heading"
  );

  if (!dropDownHeader) return;

  dropDownHeader.textContent = text;
};

const m_dropDownToggle = (item) => {
  const heading = item.querySelector(".snippet-tab-switcher__active-heading");

  if (!heading) return;

  heading.addEventListener("click", function () {
    this.parentElement?.classList.toggle("active");
  });
};

const addActiveClassOnButtonClick = (button) => {
  button.classList.add("snippet-tab-switcher__button--active");
};

const removeActiveClassOnButtonClick = (item) => {
  const button = item.parentElement.querySelector(
    ".snippet-tab-switcher__button--active"
  );

  if (!button) return;

  button.classList.remove("snippet-tab-switcher__button--active");
};

const slideUpContainer = (item) => {
  const activeHeading = item.querySelector(
    ".snippet-tab-switcher__button-section"
  );

  if (!activeHeading) return;

  activeHeading.classList.remove("active");
};

const setActiveClassOnSection = (item, idx) => {
  const sections = item.querySelectorAll(
    ".snippet-tab-switcher__info-container"
  );
  sections[idx].classList.add("snippet-tab-switcher__info-container--active");
};

const removeActiveClassOnSection = (item) => {
  const sections = item.querySelectorAll(
    ".snippet-tab-switcher__info-container"
  );
  sections.forEach((section) => {
    section.classList.remove("snippet-tab-switcher__info-container--active");
  });
};

const changeHrefOnLinkClick = (item: HTMLElement, button: HTMLButtonElement) => {
  const link = item.querySelector(".snippet-tab-switcher__link");
  const href = button.getAttribute("data-link");
  if (!link || !href) return;

  href !== "" ? (link.setAttribute("href", href)) : null;
}